import { useEffect, useRef } from "react";
import { toast } from "sonner";

// Opens + highlights a record referenced by ?booking= / ?enquiry= once the list has loaded.
export function useFocusRecord(focusId, rows, loading, setSelected, testIdPrefix) {
  const done = useRef(false);
  useEffect(() => {
    if (!focusId || done.current || loading) return;
    done.current = true;
    const rec = rows.find((r) => r.id === focusId);
    if (!rec) {
      toast.error("Rezervarea din link nu a fost găsită (posibil ștearsă).");
      return;
    }
    setSelected(rec);
    document.querySelector(`[data-testid="${testIdPrefix}${focusId}"]`)?.scrollIntoView({ block: "center" });
  }, [focusId, rows, loading, setSelected, testIdPrefix]);
}
